import { useSelectedTenantStore } from '@/stores/useSelectedTenantStore'
import { useContext } from 'react'
import { AuthContext } from '@/contexts/AuthContext'

export function useIdTokenAndTenantId() {
  const { idToken } = useContext(AuthContext)
  const TENANT_ID = useSelectedTenantStore((state) => state.selectedTenantId)
  // No navigation effect — beforeLoad in _authenticated.tsx handles all redirects
  return { idToken, TENANT_ID }
}
